(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-image-flash"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-image-collage')) {
  customElements.define('collection-image-collage', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const frame = this.querySelector('[data-collection-collage-frame]');
      const data = this.querySelector('[data-collection-collage-images]');
      if (!frame || !data) return;

      let items = [];
      try {
        items = JSON.parse(data.textContent).filter(item => item?.src);
      } catch {
        return;
      }
      if (items.length < 2) return;

      for (let index = items.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
      }
      this.items = items.slice(0, 4);

      const grid = document.createElement('div');
      grid.className = 'collection-image-collage-grid';
      for (const item of this.items) {
        const image = document.createElement('img');
        image.src = item.src;
        image.alt = item.alt || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        grid.append(image);
      }
      frame.replaceChildren(grid);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["runway-collection-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('runway-collection-card')) {
  customElements.define('runway-collection-card', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.video.muted = true;
      this.manualPause = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.sync = () => {
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
        this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
      };
      this.video.addEventListener('play', this.sync);
      this.video.addEventListener('pause', this.sync);
      this.button.addEventListener('click', () => {
        this.manualPause = !this.video.paused;
        if (this.video.paused) this.video.play().catch(this.sync);
        else this.video.pause();
      });
      this.visibility = () => {
        if (document.hidden || !this.visible) this.video.pause();
        else if (!this.manualPause && !this.reduced.matches) this.video.play().catch(this.sync);
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.visibility();
      }, {threshold: 0.25});
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.visibility);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.visibility);
      this.video?.pause();
      this.started = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
